import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useHotelAdminStore } from './store'

// Pages - Guests (QR Registration only)
import GuestQRRegistrationPage from './pages/GuestQRRegistrationPage'
import GuestRegistration from './pages/GuestRegistration'
import GuestRegistrationSuccessPage from './pages/GuestRegistrationSuccessPage'

// Pages - Hotel Admins
import LandingPage from './pages/LandingPage'
import AdminLoginPage from './pages/AdminLoginPage'
import AdminLoginProtectedPage from './pages/AdminLoginProtectedPage'
import AdminRegisterPage from './pages/AdminRegisterPage'
import AdminRegisterProtectedPage from './pages/AdminRegisterProtectedPage'
import AdminVerifyEmailPage from './pages/AdminVerifyEmailPage'
import AdminVerifyEmailSentPage from './pages/AdminVerifyEmailSentPage'
import AdminSubscriptionSelectPage from './pages/AdminSubscriptionSelectPage'
import AdminPaymentSuccessPage from './pages/AdminPaymentSuccessPage'
import HotelAdminDashboardPage from './pages/HotelAdminDashboardPage'

// Pages - Owner
import OwnerLoginPage from './pages/OwnerLoginPage'
import OwnerDashboardPage from './pages/OwnerDashboardPage'

// Pages - Referral
import ReferralPage from './pages/ReferralPage'

// Components
import Layout from './components/Layout'
import { ProtectedRoute } from './components/ProtectedRoute'

function App() {
  const hotelAdmin = useHotelAdminStore((state) => state.admin)

  return (
    <Router>
      <Layout>
        <Routes>
          {/* Public Routes - QR Guest Registration */}
          <Route path="/guest/:adminId" element={<GuestQRRegistrationPage />} />
          <Route path="/guest/:adminId/registration" element={<GuestRegistration />} />
          <Route path="/guest/:adminId/success" element={<GuestRegistrationSuccessPage />} />
          
          {/* Admin Routes - Open Registration */}
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path="/admin-register-open" element={<AdminRegisterPage />} />
          
          {/* Protected Hotel Admin Routes */}
          <Route path="/admin-login-code" element={<AdminLoginProtectedPage />} />
          <Route path="/admin-register" element={<AdminRegisterProtectedPage />} />
          <Route path="/admin-verify-email-sent" element={<AdminVerifyEmailSentPage />} />
          <Route path="/admin-verify-email" element={<AdminVerifyEmailPage />} />
          <Route path="/admin-subscription-select" element={<AdminSubscriptionSelectPage />} />
          <Route path="/admin/payment-success" element={<AdminPaymentSuccessPage />} />
          
          {/* Owner Routes */}
          <Route path="/owner-login" element={<OwnerLoginPage />} />
          <Route path="/owner/dashboard" element={<OwnerDashboardPage />} />

          {/* Referral Page */}
          <Route path="/referral" element={
            <ProtectedRoute requireAdmin>
              <ReferralPage />
            </ProtectedRoute>
          } />

          {/* Hotel Admin Dashboard */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute requireAdmin>
              <HotelAdminDashboardPage />
            </ProtectedRoute>
          } />
          
          {/* Landing Page */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Catch-all routes */}
          {hotelAdmin ? (
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
          ) : (
            <Route path="*" element={<Navigate to="/" replace />} />
          )}
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
